<template>
    <el-drawer
        title="链接数据统计"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content" v-loading="dataLoading">
            <div v-if="dataList.length > 0" class="page-btns-box">
			小程序URL：{{dataList[0].path}}
                <span class="ML20"><el-button v-if="$utils.have('/tdc/download/cardList')" type="primary" icon="el-icon-download" size="small"
                    @click="download" :loading="downLoading">导出</el-button></span>
            </div>
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" size="small" stripe>
                    <el-table-column label="url演出详情页pv" prop="pv"></el-table-column>
                    <el-table-column label="url演出详情页uv" prop="uv"></el-table-column>
                    <el-table-column label="url详情页停留时长" prop="duration"></el-table-column>
                    <el-table-column label="url演出购票按钮点击次数" prop="buyClickCount"></el-table-column>
                    <el-table-column label="url演出下单人数" prop="allUserCount"></el-table-column>
                    <el-table-column label="url演出下单数" prop="orderCount"></el-table-column>
                    <el-table-column label="url演出下单金额" prop="orderUserAmountStr"></el-table-column>
                    <el-table-column label="url复购参演艺人人数" prop="repurchaseUserCount"></el-table-column>
                    <el-table-column label="url复购参演艺人订单数" prop="repurchaseOrderCount"></el-table-column>            		
                </el-table>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
            
        </div>
    </el-drawer>
</template>
<script>
import { downloadFileTmp } from '@/assets/js/commonApi.js';

export default {
    
    data(){
        return{
            drawerShow: false,
            downLoading: false,
            dataLoading: false,            
            id:'',
			dataList:[],
        }
    },
	
    methods:{
        close(){
            
            this.drawerShow = false;
            
        },
        show(obj){
            if( obj ){
                this.id = obj.id
				this.getData()
            }
            this.drawerShow = true;
			
        },
        
        getData() {
			this.dataLoading = true
            this.$request({
                url: "/applet/link/statistic",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
						this.dataLoading = false
                        let dataArray = [];
						dataArray.push(result)
						this.dataList = dataArray
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
        },
        async download() {
            let filePath;
            this.downLoading = true;
            const res = await this.$request({
                url: '/applet/link/export',
                method: 'post',
                params: { id: this.id }
            })
                .catch(err => {
                    this.$message({ message: err.message, type: 'error' });
                })
            const { state, msg, result } = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            } else {
                return this.$message.error(msg || '下载失败');
            }
        
            await downloadFileTmp(filePath, `${this.id}链接数据统计.xlsx`);
            this.downLoading = false;
        },
    }
}
</script>

<style lang="scss" scoped>

</style>